import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '../../environments/environment';

export const AUTH_CONFIG: AuthConfig = {
  // Url of the Identity Provider
  issuer: environment.sso,

  // URL of the SPA to redirect the user to after login
  redirectUri: window.location.origin + environment.baseUrl + 'index.html',

  // URL of the SPA to redirect the user after silent refresh
  silentRefreshRedirectUri:
    window.location.origin + environment.baseUrl + 'silent-refresh.html',

  // The SPA's id. The SPA is registerd with this id at the auth-server
  clientId: '1bca97d3-3e63-4bb7-b82b-0a597f164852',

  // set the scope for the permissions the client should request
  // The first three are defined by OIDC. The 4th is a usecase-specific one
  scope:
    'openid email profile api://1bca97d3-3e63-4bb7-b82b-0a597f164852/webapi',

  resource: environment.userdetail,
  //requestAccessToken: false,

  //disable strict validation for Azure AD Endpoints
  strictDiscoveryDocumentValidation: false,

  showDebugInformation: true,
};

export enum SecurityPolicies {
  HasWebAccess,
  RequireSuperUser,
  RequiresManageThemes,
  RequiresPrimaryContact,
  RequiresManageOrganizationsOrPremiumServices,
  RequiresManageAlarms,
  RouteOrgHasAnomalyDetection,
  RouteOrgIsBillagleOrg,
  RequiresThemingAndHasManageOrgs,
  RequiresManageTanks,
  RequiresManageCallSchedule,
  RequiresManageUsers,
  RequiresManageLocations,
  RequiresManageOrganizations,
  CanMoveTank,
  RequiresManageFilterProfile,
  RequireSuperUserOrManageOrgs,
  RequiresManageProducts,
  RequiresManageTankProfile,
  RequiresManageDiagnostics
}
